import {Controller} from "stimulus";
import DateTimePickerRenderer from "./date_time_picker_renderer";
import $ from 'jquery';

export default class extends Controller {
  static values = {index: Number, pickerConfig: Object};
  static targets = [
    "day",
    "selectionsContainer",
    "selection",
    "selectionTemplate",
    "next",
    "previous",
    "datePicker",
    "selectedNotice",
    "daysContainer",
    "limitedAvailabilityWarning",
    "reducingAvailabilityNotice",
  ];

  initialize() {
    this.renderPicker();
  }

  connect() {
    this.initialSelectedSlots = this.selectionTargets.length;
    this.updateSelectedNotice();
    this.updateLimitedAvailabilityWarning();
    this.setupFormValidation();
  }

  get form() {
    if (!this._form) {
      this._form = this.element.closest('form');
    }
    return this._form;
  }

  setupFormValidation() {
    if (!this.form) return;

    $(this.form).on('custom-validation', this.validateSelections.bind(this));
  }

  validateSelections(event, errorCount) {
    if (this.allSelectionsLimitedAvailability()) {
      errorCount += 1;
      this.showErrorState();
    } else {
      this.clearErrorState();
    }

    $(this.form).trigger('custom-validation-callback', [errorCount]);
  }

  showErrorState() {
    this.limitedAvailabilityWarningTarget.classList.add('show', 'error');
    this.limitedAvailabilityWarningTarget.scrollIntoView({behavior: 'smooth', block: 'end'});
  }

  clearErrorState() {
    this.limitedAvailabilityWarningTarget.classList.remove('error');
  }

  renderPicker() {
    const renderer = new DateTimePickerRenderer(this.daysContainerTarget, this.pickerConfigValue);
    renderer.render();
  }

  slotSelected(event) {
    const slot = event.detail.slot;
    const newInput = this.selectionTemplateTarget.content.cloneNode(true).querySelector("input");
    newInput.value = slot.dataset.value;
    newInput.dataset.date = slot.dataset.date;
    this.selectionsContainerTarget.appendChild(newInput);
    this.clearErrorState();
    this.updateSelectedNotice();
    this.updateLimitedAvailabilityWarning();
    this.updateReducingAvailabilityNotice();
    this.updatePrioritySlotFee();
  }

  slotUnselected(event) {
    const slot = event.detail.slot;
    const inputToRemove = this.selectionTargets.find(
      input => input.value === slot.dataset.value
    );
    this.selectionsContainerTarget.removeChild(inputToRemove);
    this.clearErrorState();
    this.updateSelectedNotice();
    this.updateLimitedAvailabilityWarning();
    this.updateReducingAvailabilityNotice();
    this.updatePrioritySlotFee();
  }

  dateChanged(event) {
    const date = event.target.value;
    const day = this.dayTargets.find(day => day.dataset.value === date);
    this.indexValue = this.dayTargets.indexOf(day);
  }

  rightArrowClicked() {
    if (this.indexValue < this.dayTargets.length - 1) {
      this.indexValue++;
    }
  }

  leftArrowClicked() {
    if (this.indexValue > 0) {
      this.indexValue--;
    }
  }

  indexValueChanged(newValue, oldValue) {
    this.previousTarget.classList.toggle("disabled", this.indexValue === 0);
    this.nextTarget.classList.toggle("disabled", this.indexValue === this.dayTargets.length - 1);
    this.scrollToCurrentIndex(oldValue);
  }

  scrollToCurrentIndex(previousIndex) {
    const dayElement = document.getElementById(`day-${this.indexValue}`);
    this.datePickerTarget.value = dayElement.dataset.value;
    const scrollBehavior = Math.abs(this.indexValue - previousIndex) > 6 ? "instant" : "smooth";
    dayElement.scrollIntoView({
      behavior: scrollBehavior,
      block: "nearest",
      inline: "start"
    });
  }

  updateSelectedNotice() {
    const uniqueDates = this.uniqueDatesSelected();
    if (uniqueDates.size > 0) {
      this.selectedNoticeTarget.classList.add('show');
      this.selectedNoticeTarget.querySelector('span').textContent =   `${uniqueDates.size} date${uniqueDates.size > 1 ? 's' : ''}`;
    } else {
      this.selectedNoticeTarget.classList.remove('show');
    }
  }

  updateLimitedAvailabilityWarning() {
    if (!this.hasLimitedAvailabilityWarningTarget) return;

    if (this.allSelectionsLimitedAvailability()) {
      this.limitedAvailabilityWarningTarget.classList.add('show');
    } else {
      this.limitedAvailabilityWarningTarget.classList.remove('show');
    }
  }

  allSelectionsLimitedAvailability() {
    const selectedDates = this.uniqueDatesSelected();
    if (selectedDates.size === 0) return false;

    const limitedAvailabilityDates = this.pickerConfigValue.limitedAvailabilityDates || [];
    return [...selectedDates].every(date => limitedAvailabilityDates.includes(date));
  }

  updatePrioritySlotFee() {
    const priorityDates = this.pickerConfigValue.priorityDates || [];
    const selectedDates = this.uniqueDatesSelected();
    const prioritySlotSelected = [...selectedDates].some(date => priorityDates.includes(date));
    this.element.dispatchEvent(
      new CustomEvent('prioritySlotFeeChanged', {detail: {added: prioritySlotSelected}, bubbles: true})
    );
  }

  updateReducingAvailabilityNotice() {
    if (!this.hasReducingAvailabilityNoticeTarget) return;

    this.reducingAvailabilityNoticeTarget.classList.toggle(
      'hidden',
      this.selectionTargets.length >= this.initialSelectedSlots
    );
  }

  uniqueDatesSelected() {
    return new Set(this.selectionTargets.map(target => target.dataset.date));
  }
}
